<template>
    <div class="flex flex-wrap items-center gap-4">
        <template v-if="displayCountries.length">
            <img
                v-for="c in displayCountries"
                :key="c.code"
                :src="flagSrc(c.flag)"
                :alt="c.translated?.name || c.code"
                :title="c.translated?.name || c.code"
                class="h-10 w-auto max-w-[2.5rem] object-contain flex-shrink-0 rounded-sm"
                loading="lazy"
            />
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { flagSrc } from '../utils/flagSrc.js';

const TEAM4_COUNTRY_CODES = ['IN', 'CZ', 'DE', 'PL', 'AT', 'FR'];

export default {
    name: 'Team4Flags',
    props: {
        mobile: { type: Boolean, default: false }
    },
    methods: {
        flagSrc,
    },
    computed: {
        ...mapGetters('form', ['countries']),
        displayCountries() {
            const list = this.countries || [];
            return TEAM4_COUNTRY_CODES.map((code) =>
                list.find((c) => (c.code || '').toUpperCase() === code)
            ).filter(Boolean);
        }
    },
    mounted() {
        if (!(this.countries || []).length) {
            this.$store.dispatch('form/loadInitialData').catch(() => {});
        }
    }
};
</script>
